// @flow

import { get } from "../_common/fetch";

import { h } from "../_common/jsx-dom.svg.js";

import "./postcode-update.scss";

const TAG = "postcode-update";

const ENTER_KEYCODE = 13;

const BRANCH_LOOKUP_URL = "/trsonline/components/api/branches";

function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

class PostcodeUpdate extends HTMLElement {
    _eleWrap;
    _eleInput;
    _eleErrorMessage;
    _isLoading;
    constructor() {
        super();
        this._isLoading = false;
    }
    connectedCallback() {
        this._eleWrap = (
            <div>
                <input
                    ref={r => (this._eleInput = r)}
                    onKeydown={this._onKeyDownTriggered}
                    type={this._attr("type", "text")}
                    name={this._attr("name", "customerpostcode")}
                    placeholder={this._attr("placeholder", "Postcode")}
                    class={this._attr("input-class", "")}
                    style={this._attr("input-style", "")}
                    inputmode={this._attr("inputmode", "numeric")}
                    minlength={this._attr("minlength", "4")}
                    maxlength={this._attr("maxlenght", "4")}
                    min={this._attr("min", "0")}
                    max={this._attr("max", "9999")}
                    pattern={this._attr("pattern", "[0-9]*")}
                />
                <div
                    ref={r => (this._eleErrorMessage = r)}
                    class={this._attr("error-class", "error-message")}
                    style="display: hidden;"
                />
            </div>
        );
        if (this.hasAttribute("autofocus"))
            this._eleInput.setAttribute("autofocus", true);
        this.appendChild(this._eleWrap);
    }
    focus = () => {
        this._eleInput.focus();
    };
    blur = () => {
        this._eleInput.blur();
    };
    clearInput = () => {
        this._eleInput.value = "";
    };
    _attr = (n, defVal) => {
        return this.getAttribute(n) || defVal;
    };
    _onKeyDownTriggered = e => {
        if (e.which === ENTER_KEYCODE) {
            this.triggerPostcodeUpdate();
        }
    };
    _updateIsLoading = bln_isLoading => {
        this._isLoading = bln_isLoading;
        const cls = this._attr("loading-class", "loading");
        if (bln_isLoading) {
            this._eleInput.classList.add(cls);
        } else {
            this._eleInput.classList.remove(cls);
        }
    };
    _updateErrorMessage = msg => {
        this._eleErrorMessage.style.display = msg ? "" : "none";
        this._eleErrorMessage.innerHTML = msg;
    };
    _searchNearestBranch = async postcode => {
        const resp = await get(BRANCH_LOOKUP_URL, {
            postcode
        });
        return await resp.json();
    };
    _dispatchPostcodeUpdatedEvent = postcode => {
        this.dispatchEvent(
            new CustomEvent("postcode-update__postcode-updated", {
                bubbles: true,
                detail: {
                    postcode
                }
            })
        );
    };
    triggerPostcodeUpdate = async () => {
        const val = this._eleInput.value;
        if (isNumeric(val) && val.length === 4) {
            this._updateIsLoading(true);
            try {
                const result = await this._searchNearestBranch(val);
                if (result && result.length > 0) {
                    this._updateErrorMessage();
                    const cookieValue = this._setPostCodeResult(val, result[0]);
                    this._dispatchPostcodeUpdatedEvent(cookieValue);
                } else {
                    this._updateErrorMessage(
                        "No branches found, please try again."
                    );
                }
                this._updateIsLoading(false);
            } catch (e) {
                this._updateIsLoading(false);
                this._updateErrorMessage(
                    "There was an error, please try again later."
                );
            }
        } else {
            this._updateErrorMessage("Please enter a valid postcode.");
        }
    };
    _setPostCodeResult = (userpostcode, branch) => {
        var state = branch.costStateCode.replace(/^0+/, "");
        var branchCode = branch.branchCode.replace(/^0+/, "");
        var cookieValue = {
            state: state,
            postCode: userpostcode,
            branchCode: branchCode
        };
        var expires = new Date(new Date().getTime() + 365 * 86400000);
        document.cookie =
            "reece-user-location=" +
            encodeURIComponent(JSON.stringify(cookieValue)) +
            "; expires=" +
            expires.toUTCString() +
            "; path=/";
        return cookieValue;
    };
}

customElements.define(TAG, PostcodeUpdate);



// WEBPACK FOOTER //
// ./src/postcode-update/postcode-update.js